import React from 'react';
import { ArrowRight, Globe2 } from 'lucide-react';
import { Button } from './ui/button';

const Hero = ({ scrollToSection }) => {
  return (
    <section className="pt-32 pb-20 px-6 bg-gradient-to-br from-cyan-100 via-purple-100 to-pink-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-5xl md:text-6xl font-serif font-bold text-gray-900 leading-tight">
                Oluwatobi I. Abiola-Adeyemo
              </h1>
              <p className="text-xl text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-purple-600 font-semibold">
                Strategic Program Leader | Business Consultant | Author | Speaker
              </p>
            </div>
            <p className="text-lg text-gray-700 leading-relaxed">
              Supporting organizations, entrepreneurs, and communities through leadership programs, strategic initiatives, and impactful storytelling.
            </p>
            <div className="flex flex-wrap gap-4">
              <Button
                onClick={() => scrollToSection('work')}
                className="bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white px-6 py-6 text-base shadow-lg hover:shadow-xl"
                data-testid="hero-view-work-btn"
              >
                View My Work <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
              <Button
                onClick={() => scrollToSection('books')}
                className="bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white px-6 py-6 text-base shadow-lg hover:shadow-xl"
                data-testid="hero-explore-books-btn"
              >
                Explore My Books
              </Button>
              <Button
                onClick={() => scrollToSection('global-360-child')}
                className="bg-gradient-to-r from-amber-400 via-orange-500 to-pink-500 hover:from-amber-500 hover:via-orange-600 hover:to-pink-600 text-white px-6 py-6 text-base shadow-lg hover:shadow-xl font-semibold"
                data-testid="hero-global-360-btn"
              >
                <Globe2 className="mr-2 h-4 w-4" />
                Discover Global 360° Child
              </Button>
              <Button
                onClick={() => scrollToSection('speaking')}
                className="bg-gradient-to-r from-rose-500 to-pink-500 hover:from-rose-600 hover:to-pink-600 text-white px-6 py-6 text-base shadow-lg hover:shadow-xl font-semibold"
                data-testid="hero-invite-speak-btn"
              >
                Invite Me to Speak
              </Button>
            </div>
          </div>
          <div className="flex justify-center md:justify-end">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-teal-200 to-purple-200 rounded-lg transform rotate-3 opacity-50"></div>
              <img
                src="https://customer-assets-gfyr7b9c.emergentagent.net/job_leadership-impact-3/artifacts/gx9db5qt_IMG_2453.jpeg"
                alt="Oluwatobi I. Abiola-Adeyemo"
                className="relative w-full max-w-md object-cover"
                style={{ mixBlendMode: 'multiply' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;